//@ts-nocheck
import React,{useEffect, useState} from 'react';
import { Table } from 'react-bootstrap';
import { changeDateFormat } from "../bookingConfirmation/Utils/CommenFunction"
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { setPnr, setBookingDetails, setItenaryData } from "../bookingConfirmation/ActionCreator/flightBooking"
import { setBookingItinenary,setBookingFareId,setTripType,setProvideId, setDepartDate } from "../bookingConfirmation/ActionCreator/searchForm"
import SpinnerLoader from '../bookingConfirmation/Utils/spinner';
import { setAdultMarkupValue, setChildMarkupValue, setInfantMarkupValue } from "../bookingConfirmation/ActionCreator/searchForm"
// import { setBookingWithQuote } from '../bookingConfirmation/ActionCreator/myq';
import sort1 from "../bookingConfirmation/Images/sort-1.svg";
import sort2 from "../bookingConfirmation/Images/sort-2.svg";
import sort3 from "../bookingConfirmation/Images/sort-3.svg";
import {bookingStatus} from "../bookingConfirmation/Utils/Constant";
import { useSelector } from "react-redux";
import moment from "moment-timezone";
import TextField from "@material-ui/core/TextField";
import { resetMyFilesFilters } from '../bookingConfirmation/ActionCreator/myFiles';
// import { setCancellationConfirmation } from "../bookingConfirmation/ActionCreator/flightBooking"
import { setUUID } from "../bookingConfirmation/ActionCreator/searchForm"

const CONFIG = {
  "Sabre": { showAirlineRecordLocator: false, showWebIndicator: false },
  "Sabre_NDC": { showAirlineRecordLocator: false, showWebIndicator: true },
  "Amadeus_NDC": { showAirlineRecordLocator: false, showWebIndicator: true },
  "NDC": { showAirlineRecordLocator: false, showWebIndicator: true },
  "HS_NDC_Aggregator": { showAirlineRecordLocator: false, showWebIndicator: true },
  "TwoOneWay": { showAirlineRecordLocator: false, showWebIndicator: false },
  "TwoOneWayNDC": { showAirlineRecordLocator: false, showWebIndicator: true }
}



export default function Allpnrbooking(props) {
  let { myFilesData } = props
  let isLoading = props.isLoading
  let isLoader = props.isLoader
  const dispatch = useDispatch();
  const history = useHistory();

  const displayProviderName = [
    { key: "Sabre", value: "Sabre GDS" },
    { key: "Sabre_NDC", value: "Sabre NDC" },
    { key: "Amadeus_NDC", value: "Amadeus NDC" },
    { key: "NDC", value: "Duffel" },
    { key: "HS_NDC_Aggregator", value: "HIS NDC" }
  ]

  const providerNameMap = Object.fromEntries(
    displayProviderName.map((item) => [item.key, item.value])
  );

  const isInternalUserAutheticated = useSelector((state) => state.internalUser.isInternalUserAutheticated);
  const resetFilters = useSelector((state) => state.myFile.resetFilters);
  const [isStatusAsc,setStatusAsc] = useState("")
  const [isReserveAsc,setReservationAsc] = useState("")
  const [isDepartAsc,setDeaprtAsc] = useState("")
  const [isPaxAsc,setPaxAsc] = useState("")
  const [isAgentAsc,setAgentAsc] = useState("")
  const [isDestinationAsc,setDestinationAsc] = useState("")
  const [isPnrAsc,setPnrAsc] = useState("")
  const [statusCode,setStatusCode] = useState([])
  const [showCarrier,setShowCarrier] = useState(false)
  const [isCarrierAsc,setCarrierAsc] = useState("")
  const [filters, setFilters] = useState({
    status: "",
    reservation: "",
    departure: "",
    paxNames: "",
    agentName: "",
    carrier: "",
    provider: "",
    pnr: ""
  });

  useEffect(()=>{
    if(myFilesData && myFilesData.length>0){
      const hasValidatingCarrier = myFilesData.some(item => "validatingCarrier" in item);
      setShowCarrier(hasValidatingCarrier);
    }

  },[myFilesData])

  const getPnrDetails = (pnrNO, bookingResult) => {
    let tripType = bookingResult&&bookingResult.tripType;
    let fareId = bookingResult&& bookingResult.bookingDetails && bookingResult.bookingDetails.itineraryFare && bookingResult.bookingDetails.itineraryFare.id;
    if (pnrNO) {
      dispatch(setPnr(pnrNO))
      dispatch(setBookingDetails([]))
      dispatch(setItenaryData([]))
      dispatch(setBookingItinenary(""))
      //dispatch(setBookingFareId(fareId))
      dispatch(setTripType(tripType))
      dispatch(setProvideId(bookingResult &&  bookingResult.bookingDetails&& bookingResult.bookingDetails.itineraryFare && bookingResult.bookingDetails.itineraryFare.providerId))
      dispatch(setAdultMarkupValue(0))
      dispatch(setChildMarkupValue(0))
      dispatch(setInfantMarkupValue(0))
      // dispatch(setCancellationConfirmation(false))
      if(bookingResult?.bookingCorrelationId) {
        dispatch(setUUID(bookingResult.bookingCorrelationId))
      }
      history.push("/booking-confirmation")
    }

  }

  
  const sortStatus =()=>{
      props.sortData("status", isStatusAsc)
      setStatusAsc(isStatusAsc==="" ?true:!isStatusAsc)
  }

  const sortReservation =()=>{
    props.sortData("reservation", isReserveAsc)
    setReservationAsc(isReserveAsc===""?true:!isReserveAsc)
  }

  const sortDeparture =()=>{
    props.sortData("departure", isDepartAsc)
    setDeaprtAsc(isDepartAsc==="" ?true :!isDepartAsc)
  }

  const sortPaxName =()=>{
    props.sortData("paxName", isPaxAsc)
    setPaxAsc(isPaxAsc===""?true:!isPaxAsc)
  }

  const sortAgentName =()=>{
    props.sortData("agentName", isAgentAsc)
    setAgentAsc(isAgentAsc===""?true:!isAgentAsc)
  }

  const sortDestination =()=>{
    props.sortData("destination", isDestinationAsc)
    setDestinationAsc(isDestinationAsc===""?true:!isDestinationAsc)
  }

  const sortPnr =()=>{
    props.sortData("pnr", isPnrAsc)
    setPnrAsc(isPnrAsc===""?true:!isPnrAsc)
  }

  const sortCarrier =()=>{
    props.sortData("carrier", isCarrierAsc)
    setCarrierAsc(isCarrierAsc===""?true:!isCarrierAsc)
  }

  const myFilesBookingStatus = {
    "NP": "ON HOLD",
    "PNP": "PAID",
    "PT": "TICKETED",
    "NTC": "CANCELLED",
    "TC": "CANCELLED",
    "PNTC": "CANCELLED",
    "CR": "CANCELLED",
    "CU": "CONTACT US",
    "SC": "SCHEDULE CHANGE",
    "TF": "TICKETING FAILED",
    "PD": "PAID"
  }

  const handleFilterChange = (e) => {
    if(e.target.name && e.target.value !== undefined){
      setFilters({
        ...filters,
        [e.target.name]: e.target.value
      });
    }
  };

  useEffect(() => {
    if(filters && Object.keys(filters).length > 0){
      props?.applyFilters(filters);
    }
  },[filters]);

  useEffect(() => {
    if (resetFilters) {
      dispatch(resetMyFilesFilters(false))
      setFilters({
        status: "",
        reservation: "",
        departure: "",
        paxNames: "",
        agentName: "",
        carrier: "",
      });
    }
  }, [resetFilters]);

  const isTimeoutErrorFlag = useSelector((state) => state.myFileError.myFilesDataError);
  const [isTimeoutError ,setIsTimeoutError] =  useState(isTimeoutErrorFlag)
  useEffect(()=>{
    setIsTimeoutError(isTimeoutErrorFlag)
  },[isTimeoutErrorFlag])
  



  return (
    <div className="pnrdata">
      {isLoading || isLoader ?
        <>
         <div className="col-md-12 text-center mt-3">
          {isTimeoutError === false ? <SpinnerLoader /> : "A technical error has occurred. Please try again."
          
            }
         </div>
        </>
        :
      <> <Table responsive="sm" className="pnrbookintable " >
        <thead>
          <tr>
            <th className="">
              <div onClick={sortStatus} style={{width:"150px"}}>
                Status
                {isStatusAsc === "" && <img className=" ml-1 mb-1" src={sort1} />}
                {isStatusAsc === true && <img className="ml-1 mb-1" src={sort2} />}
                {isStatusAsc === false && <img className=" ml-1 mb-1" src={sort3} />}
              </div>
            </th>

            <th className="secondthtd " >
              <div onClick={sortReservation}>
                Reservation
                {isReserveAsc === "" && <img className=" ml-1 mb-1" src={sort1} />}
                {isReserveAsc === true && <img className=" ml-1 mb-1" src={sort2} />}
                {isReserveAsc === false && <img className=" ml-1 mb-1" src={sort3} />}
              </div>
              
              {props?.from == "sortBy" &&
                <TextField
                variant="outlined"
                placeholder="Search Reservation"
                onChange={(e) => handleFilterChange(e)}
                name="reservation"
                value={filters.reservation}
                InputProps={{
                  style: { "height": "28px", "fontSize": "14px" }
                }}
                inputProps={{
                  style: { padding: "4px 8px", fontSize: "16px" }
                }}
              />}
            </th>

            <th className="" >
              <div onClick={sortDeparture}>
                Departure
                {isDepartAsc === "" && <img className=" ml-1 mb-1" src={sort1} />}
                {isDepartAsc === true && <img className=" ml-1 mb-1" src={sort2} />}
                {isDepartAsc === false && <img className=" ml-1 mb-1" src={sort3} />}
              </div>
              
              {props?.from == "sortBy" &&
                <TextField
                variant="outlined"
                placeholder="Search Departure"
                onChange={(e) => handleFilterChange(e)}
                name="departure"
                value={filters.departure}
                InputProps={{
                  style: { "height": "28px", "fontSize": "14px" }
                }}
                inputProps={{
                  style: { padding: "4px 8px", fontSize: "16px" }
                }}
              />}
            </th>

            <th className="" >
              <div onClick={sortPaxName}>
              Pax Names
            {isPaxAsc==="" &&<img className=" ml-1 mb-1" src={sort1}/>} 
            {isPaxAsc ===true && <img className=" ml-1 mb-1" src={sort2}/>} 
            {isPaxAsc===false && <img className=" ml-1 mb-1" src={sort3}/>}
              </div>

              {props?.from == "sortBy" &&
              <TextField
                variant="outlined"
                placeholder="Search Pax"
                onChange={(e) => handleFilterChange(e)}
                name="paxNames"
                value={filters.paxNames}
                InputProps={{
                  style: { "height": "28px", "fontSize": "14px" }
                }}
                inputProps={{
                  style: { padding: "4px 8px", fontSize: "16px" }
                }}
              />}
            </th>

            <th className="fifththtd " >
              <div onClick={sortAgentName}>
              Agent Name
            {isAgentAsc==="" &&<img className=" ml-1 mb-1" src={sort1}/>} 
            {isAgentAsc ===true && <img className=" ml-1 mb-1" src={sort2}/>} 
            {isAgentAsc===false && <img className=" ml-1 mb-1" src={sort3}/>}
              </div>
              {props?.from == "sortBy" &&
              <TextField
                variant="outlined"
                placeholder="Search Agent"
                onChange={(e) => handleFilterChange(e)}
                name="agentName"
                value={filters.agentName}
                InputProps={{
                  style: { "height": "28px", "fontSize": "14px" }
                }}
                inputProps={{
                  style: { padding: "4px 8px", fontSize: "16px" }
                }}
              />}
            </th>

            {showCarrier &&
              <th className="" >
                <div onClick={sortCarrier}>

                Carrier
                {isCarrierAsc === "" && <img className=" ml-1 mb-1" src={sort1} />}
                {isCarrierAsc === true && <img className=" ml-1 mb-1" src={sort2} />}
                {isCarrierAsc === false && <img className=" ml-1 mb-1" src={sort3} />}
                </div>
                {props?.from == "sortBy" &&
                <TextField
                  variant="outlined"
                  placeholder="Search Carrier"
                  onChange={(e) => handleFilterChange(e)}
                  value={filters.carrier}
                  name="carrier"
                  InputProps={{
                    style: { "height": "28px", "fontSize": "14px" }
                  }}
                  inputProps={{
                    style: { padding: "4px 8px", fontSize: "16px" }
                  }}
                />}
              </th>
            }

            {
              <th className="" >
                <div onClick={sortDestination}>
                Provider
                {isDestinationAsc === "" && <img className=" ml-1 mb-1" src={sort1} />}
                {isDestinationAsc === true && <img className=" ml-1 mb-1" src={sort2} />}
                {isDestinationAsc === false && <img className=" ml-1 mb-1" src={sort3} />}

                </div>
                
                  {props?.from == "sortBy" &&
                  <select
                    className="button form-control"
                    name='provider'
                    value={filters.provider}
                    onChange={(e) => handleFilterChange(e)}
                    style={{"height":"28px", fontSize:"14px", padding:"4px 8px"}}
                  >

                    {[
                      {code: "", description: "All Bookings" },
                      {code: "Sabres", description: "All Non-NDC Bookings" },
                      {code: "WEB", description: "All NDC Bookings" },
                      {code: "Sabre", description: "Sabre GDS" },
                      {code: "Sabre_NDC", description: "Sabre NDC" },
                      {code: "Amadeus_NDC", description: "Amadeus NDC" },
                      {code: "NDC", description: "Duffel" },
                      {code: "HS_NDC_Aggregator", description: "HIS NDC" }
                    ].map((type) => {
                      return (
                        <option value={type.code}>{type.description}</option>
                      )
                    })}
                  </select>}
                
              </th>
            }

            <th className="" >
              <div onClick={sortPnr}>
              PNR Number
            {isPnrAsc==="" &&<img className=" ml-1 mb-1" src={sort1}/>} 
            {isPnrAsc ===true && <img className=" ml-1 mb-1"  src={sort2}/>} 
            {isPnrAsc===false && <img  className=" ml-1 mb-1" src={sort3}/>}
              </div>
              {props?.from == "sortBy" &&
              <TextField
                variant="outlined"
                placeholder="Search PNR"
                onChange={(e) => handleFilterChange(e)}
                name="pnr"
                value={filters.pnr}
                InputProps={{
                  style: { "height": "28px", "fontSize": "14px" }
                }}
                inputProps={{
                  style: { padding: "4px 8px", fontSize: "16px" }
                }}
              />}
            </th>


          </tr>
        </thead>
       
        <tbody>
          {myFilesData && myFilesData.length > 0 ?
            myFilesData.map((myFiles,i) => {
              let middleName = myFiles?.bookingDetails?.passengers[0]?.middleName !== undefined ? myFiles?.bookingDetails?.passengers[0]?.middleName : "";
              let isDufflePNR = myFiles?.providerName == "NDC"?true:false;
              let isSabreNDCPNR = myFiles?.providerName == "Sabre_NDC" ? true : false;
              let provider = (myFiles?.providerName == "Sabre" || myFiles?.providerName == "Sabre_Prod" ? "Sabre" : (myFiles?.providerName?.includes(',') && myFiles?.providerName?.includes('NDC')) ? "TwoOneWayNDC" : (myFiles?.providerName == "TwoOneWay" || myFiles?.providerName?.includes(',')) ? "TwoOneWay" : myFiles?.providerName);
              let configuration = CONFIG && CONFIG[provider] ? CONFIG[provider] : {}
              
              if(myFiles?.pnr){
                let convertedBookingDate = myFiles?.bookingDate && moment.tz(myFiles.bookingDate, "America/Chicago").tz("America/New_York");

                return (
                <tr>
                  <td><p className="capara"><span className="ca">{myFilesBookingStatus[myFiles.bookingStatusCodeSearchText] || myFiles.bookingStatusDetail?.description}</span></p></td>
                  <td className="secondthtd">
                    <>
                      {convertedBookingDate ? convertedBookingDate.format("DD MMM YYYY") : changeDateFormat(myFiles.bookingDate, "monthFormat")}
                      {convertedBookingDate && <div>
                        {convertedBookingDate.format("HH:mm:ss")} ET
                      </div>}
                    </>

                  </td>
                  <td>{moment(changeDateFormat(myFiles.departureDate, "monthFormat")).format("DD MMM YYYY")}</td>
                  <td>
                    {myFiles?.paxNames?.split(',')?.map((pax, idx) => (
                      <div key={idx}>{pax}</div>
                    ))}
                  </td>
                  <td className="fifththtd">{myFiles.agentName}</td>
                  {showCarrier &&
                    <td>
                      {myFiles.validatingCarrier}
                    </td>
                  }
                  {
                    <td>
                      {providerNameMap[myFiles.providerName] ?? myFiles.providerName}
                    </td>
                  }
                  <td 
                  className=''
                  onClick={() => {
                    if(myFiles.bookingCorrelationId) {
                      dispatch(setUUID(myFiles.bookingCorrelationId))
                    }
                    getPnrDetails(myFiles?.pnr, myFiles)
                  }}
                  >
                    {(configuration?.showAirlineRecordLocator && myFiles?.airlineRecordLocator) ? 
                      <div>{myFiles?.airlineRecordLocator}({myFiles?.pnr})</div>
                      :
                      <div>
                        {myFiles?.pnr}
                      </div>
                    }
                    <>
                      {(configuration?.showWebIndicator) ? <span style={{"color": "black","lineBreak": "normal"}}>WEB.NDC</span>:<></>}
                      {myFiles?.linkedPNR ? <span className="bd-errorMsg-medium">&nbsp;2OneWay</span> : <></>}
                    </>
                  </td>
                  
                </tr>
                )
              }
             }) :<>{props.isResult && <div className="mt-3 ">No result found</div>}</> }

        </tbody>
        
      </Table></>
}
    </div>
  )
}
